/**
 * Field limits and validation shared by the Content Pipeline client and API (VP-299).
 *
 * The drawer must reject exactly what `contentPipelineTaskSchema` rejects — the
 * whole board is sent as one snapshot, so a single bad field makes every later
 * save fail and the board silently falls back to localStorage.
 */

export const PIPELINE_NOTES_MAX_LENGTH = 5000;
export const PIPELINE_REFERENCE_URL_MAX_LENGTH = 2048;

/**
 * Reference/inspiration link — a real http(s) URL, never `javascript:` or a bare
 * word. An empty string means "no link" and is accepted.
 */
export function isPipelineReferenceUrl(value: string): boolean {
  const trimmed = value.trim();
  if (trimmed === "") return true;
  if (trimmed.length > PIPELINE_REFERENCE_URL_MAX_LENGTH) return false;
  try {
    const { protocol } = new URL(trimmed);
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
}
